export enum workspaceActions {
    SET_WORKSPACE = 'SET_WORKSPACE',
    SET_WORKSPACE_SETTINGS = 'SET_WORKSPACE_SETTINGS',
}
